import React from 'react'

const RupeeCurrencyIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M10 2.85498C6.06 2.85498 2.85504 6.06037 2.85504 10.0002C2.85504 13.94 6.06 17.1449 10 17.1449C13.9398 17.1449 17.145 13.94 17.145 10.0002C17.145 6.06037 13.9398 2.85498 10 2.85498ZM10 16.0179C6.6816 16.0179 3.98203 13.3183 3.98203 10.0001C3.98203 6.68154 6.6816 3.98197 10 3.98197C13.3184 3.98197 16.018 6.68154 16.018 10.0001C16.018 13.3183 13.3184 16.0179 10 16.0179Z'
        fill='#666666'
      />
      <path
        d='M13 7.27445H11.2413C11.5404 7.4886 11.7443 7.76132 11.853 8.09259H13V9.06634H11.9295C11.8751 9.49131 11.7086 9.8527 11.4299 10.1505C11.1512 10.4483 10.7655 10.6759 10.2727 10.8331L12.7349 13.7142H10.7009L8.45794 11.064C8.20986 11.064 7.97706 11.0573 7.75956 11.0439C7.54545 11.0306 7.29227 11.0122 7 10.9887V9.86943C7.25828 9.89285 7.48428 9.90958 7.67799 9.91962C7.87511 9.92631 8.113 9.92966 8.39167 9.92966C8.94223 9.92966 9.36534 9.86274 9.661 9.72889C9.96007 9.59169 10.1555 9.37084 10.2472 9.06634H7V8.09259H10.2523C10.164 7.79144 9.97536 7.58063 9.68649 7.46016C9.40102 7.33635 8.98301 7.27445 8.43246 7.27445H7V6.28564H13V7.27445Z'
        fill='#666666'
      />
    </svg>
  )
}

export default RupeeCurrencyIcon
